// color-exempt-file — retokenisation 5728fe509 : classes dark:bg-[#hex] ajoutees pour preserver le rendu dark historique (voir memoire ui-themes)
import React from "react";
import { SEOHead } from "../components/SEOHead";
import { ProductHeader } from "@core/components/layout/products/ProductHeader";
import { ProductSidebar } from "@core/components/layout/products/ProductSidebar";
import { PublicFooter } from "../components/PublicFooter";

/**
 * Gabarit commun des pages comparatives /vs/<concurrent> (registre :
 * pages/vsPages.ts) : en-tête et barre latérale de l'app, SEO de la page,
 * titre H1 et introduction centrés, puis les sections propres à chaque page.
 */
export interface VsPageLayoutProps {
  seo: {
    title: string;
    description: string;
    /** Titre complet, sans le suffixe « — DooDates » ajouté par SEOHead. */
    fullTitle?: boolean;
    jsonLd?: Record<string, unknown>;
  };
  heading: React.ReactNode;
  intro: React.ReactNode;
  children: React.ReactNode;
}

export function VsPageLayout({
  seo,
  heading,
  intro,
  children,
}: VsPageLayoutProps) {
  return (
    <div className="min-h-screen-safe bg-background dark:bg-[#030712] text-foreground">
      <SEOHead
        title={seo.title}
        description={seo.description}
        fullTitle={seo.fullTitle}
        jsonLd={seo.jsonLd}
      />
      <ProductHeader productType="date" showAuth={true} />

      <div className="flex">
        <ProductSidebar productType="date" />

        <main className="flex-1 min-w-0">
          <div className="max-w-6xl mx-auto px-6 py-16">
            <div className="text-center mb-16">
              <h1 className="text-4xl sm:text-5xl font-extrabold mb-6 text-primary">
                {heading}
              </h1>
              <p className="text-xl text-muted-foreground leading-relaxed">
                {intro}
              </p>
            </div>

            {children}
          </div>
        </main>
      </div>
      <PublicFooter />
    </div>
  );
}
